import { YStack } from "@/components";
import {
  NumberBadge,
  OptionBody,
  OptionBodyHoverWrapper,
  OptionSeparator,
} from "@/conversation/AskUserQuestionsPanel/OptionParts";

export default function YesNoStep({
  value,
  onYes,
  onNo,
}: {
  value?: boolean;
  onYes: () => void;
  onNo: () => void;
}) {
  return (
    <>
      {["Yes", "No"].map((label, index) => {
        const checked = label === "Yes" ? value === true : value === false;
        return (
          <YStack key={label}>
            {index > 0 && <OptionSeparator />}
            <OptionBodyHoverWrapper>
              <OptionBody
                label={label}
                checked={checked}
                showArrow
                badge={<NumberBadge checked={checked} index={index} />}
                onPress={label === "Yes" ? onYes : onNo}
              />
            </OptionBodyHoverWrapper>
          </YStack>
        );
      })}
    </>
  );
}
